<template>
  <v-row>
    <v-col lg="8" class="mx-auto">
      <v-card class="pa-2">
        <div class="mb-3">
          <v-text-field
            v-model="search"
            label="快速搜尋"
            single-line
            hide-details
            @keydown.enter="onSearch"
          ></v-text-field>
        </div>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="items"
          :mobile-breakpoint="0"
          :items-per-page="15"
          :disable-sort="$vuetify.breakpoint.smAndDown"
          :search="search"
          :options.sync="options"
          :server-items-length="pagination.total"
          :footer-props="footerProps"
          >
          <template v-slot:item.created_at="{ item }">
              {{ item.created_at | date('YYYY/MM/DD') }}
            </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { date } from '../../libs/filters';
import { pagination } from '../../libs/mixins';

export default {
  mixins: [
    pagination,
  ],

  filters: {
    date,
  },

  data() {
    return {
      isLoading: true,
      headers: [
        { text: '到件日期', value: 'created_at', width: '20%' },
        { text: '證號', value: 'identity_no' },
        { text: '門號種類', value: 'sim_type' },
        { text: '門號', value: 'phone' },
        { text: 'SIM卡號', value: 'sim' },
        { text: '工單號碼', value: 'tracking_no' },
        { text: '門號類型', value: 'type' },
      ],
    };
  },

  computed: {
    ...mapState('issues', {
      items: 'all'
    }),
  },

  mounted() {
    this.fetchAll();
  },

  methods: {
    ...mapActions('issues', {
      queryResults: 'get'
    }),
  }
}
</script>
